import React from 'react'
import {Card, Heading} from '@myxplor/ui'

const NotAllowedView = () => (
  <div className="layout__notAllowed">
    <Card className="authorisation--wrapper">
      <Heading>Not allowed</Heading>
      <p>You do not have access to this app</p>
    </Card>
  </div> 
)

export default NotAllowedView


// WEBPACK FOOTER //
// ./src/layout/authorised-layout/views/not-allowed.jsx